var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaptureMarkLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "40 430 215 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8CC63E",
    d: "M113.5,574.7c-8.8,0-17.3-1.5-25.2-4.9c-7.9-3-14.9-7.6-20.9-13.3c-6.1-5.8-10.9-12.7-14.6-20.9s-5.5-17-5.5-27v-0.3c0-9.4,1.8-18.2,5.2-26.4c3.3-8.2,8.2-15.2,14.3-21.2c6.1-6.1,13.3-10.6,21.5-14c8.2-3.3,17-4.9,26.7-4.9c7,0,13.3,0.9,19.4,2.4c5.8,1.5,11.2,3.9,16.1,7c4.9,3,9.1,6.4,12.7,10.6c3.6,3.9,7,8.5,9.4,13.3l-35.2,20.6c-2.4-4.6-5.5-8.2-9.1-11.2c-3.6-2.7-8.2-4.2-14-4.2c-3.6,0-7,0.6-9.7,2.1c-3,1.5-5.5,3.3-7.6,6.1c-2.1,2.4-3.6,5.5-4.9,8.8c-1.2,3.3-1.8,7-1.8,10.6v0.3c0,4.2,0.6,7.9,1.8,11.5c1.2,3.3,2.7,6.4,4.9,8.8c2.1,2.4,4.6,4.6,7.6,5.8s6.1,2.1,9.7,2.1c6.1,0,10.9-1.5,14.6-4.6c3.6-3,6.7-7,9.4-11.5l35.2,19.7c-2.7,4.9-5.8,9.1-9.4,13.3c-3.6,4.2-7.9,7.9-12.7,10.9c-4.9,3-10.6,5.5-16.7,7.3C128.3,573.7,121.4,574.7,113.5,574.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 475,
    fill: "#241F21",
    width: 35,
    height: 35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 438,
    fill: "#8CC63E",
    width: 32,
    height: 32
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 465,
    fill: "#565B5A",
    width: 24,
    height: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptureMarkLight);
export default __webpack_public_path__ + "static/media/captureMarkLight.7cf6466565c12024fd83c8e1bf91e3b4.svg";
export { ForwardRef as ReactComponent };